import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Founders from "@/components/landing/Founders";
import Pathways from "@/components/landing/Pathways";
import Pricing from "@/components/landing/Pricing";
import Stories from "@/components/landing/Stories";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-obsidian text-[#F5F5F5] font-satoshi min-h-screen overflow-x-clip" data-testid="landing-page">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Founders />
        <Pathways />
        <Pricing />
        <Stories />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
